"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackerStatus = void 0;
var TrackerStatus;
(function (TrackerStatus) {
    TrackerStatus[TrackerStatus["NONE"] = 0] = "NONE";
    TrackerStatus[TrackerStatus["DISCONNECTED"] = 1] = "DISCONNECTED";
    TrackerStatus[TrackerStatus["OK"] = 2] = "OK";
    TrackerStatus[TrackerStatus["BUSY"] = 3] = "BUSY";
    TrackerStatus[TrackerStatus["ERROR"] = 4] = "ERROR";
    TrackerStatus[TrackerStatus["OCCLUDED"] = 5] = "OCCLUDED";
    TrackerStatus[TrackerStatus["TIMED_OUT"] = 6] = "TIMED_OUT";
})(TrackerStatus = exports.TrackerStatus || (exports.TrackerStatus = {}));
